import { render, staticRenderFns } from "./rightPart.vue?vue&type=template&id=36beb945&scoped=true&"
import script from "./rightPart.vue?vue&type=script&lang=js&"
export * from "./rightPart.vue?vue&type=script&lang=js&"
import style0 from "./rightPart.vue?vue&type=style&index=0&id=36beb945&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36beb945",
  null
  
)

export default component.exports